import { Button } from '@podiumhq/design-system';

export const GoogleAutocompleteOpenManualFormLink = ({
  handleShowManualForm,
  size = 'xs',
  title = 'Enter it manually',
  buttonProps,
}) => (
  <Button
    color="blue.base"
    height="auto"
    onClick={handleShowManualForm}
    padding="0"
    size={size}
    sx={{
      '&:not([disabled]):active, &:not([disabled]):focus, &:not([disabled]):hover':
        {
          ...(!buttonProps && { backgroundColor: 'transparent' }),
        },
    }}
    variant="ghost"
    id="enter-it-manually-btn"
    data-e2e="enter-it-manually-btn"
    {...buttonProps}
  >
    {title}
  </Button>
);
